import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useSyncOfflineMonitor } from "~/hooks/useSyncOfflineMonitor";

const SyncContext = createContext(null);

export const SyncProvider = ({ children }) => {
  const syncValue = useSyncOfflineMonitor();

  return <SyncContext.Provider value={syncValue}>{children}</SyncContext.Provider>;
};

SyncProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSyncContext = () => {
  const context = useContext(SyncContext);
  if (!context) {
    throw new Error("useSyncContext deve ser usado dentro de um SyncProvider");
  }
  return context;
};

export default SyncContext;
